<div *ngIf="showPartsAppointment" class="vehicle-card" [class.flip-card]="isFlipCard" [ngClass]="!isVehicleInquiry ? 'vehicle-card' : 'inquiry-appt-card' ">
  <div class="front">
    <div class="row">
      <div class="appt-status col">
        <span [ngClass]="getAppointmentTypeClass(vehicle.appointment.appointmentType)">{{ getAppointmentTypeLabel(vehicle.appointment.appointmentType) }}</span>
        <!-- <span class="label-service" *ngIf="vehicle.appointment.appointmentType === 'Test Drive'">{{ vehicle.appointment.appointmentType }}</span> -->
      </div>
      <div class="heading-div col">
        <h6 *ngIf="isSavedForLater" [ngClass]="'pendingMessage'">{{ 'testDrive.pending' | translate}}</h6>
        <h6 *ngIf="isSavedForLater" [ngClass]="'linkSent'">{{ getLinkSentStatus()}}</h6>
        <div>
          <h6 *ngIf="isDeletePending" [ngClass]="'alertMessage'"> 
            <div class="action-btn action-icon action-btn-alert" style="margin-top: 0.2rem;"></div>&nbsp;
            {{ 'testDrive.appointmentConflict' | translate}}&nbsp;
          </h6>
        </div>
        <h6 *ngIf="vehicle?.appointment?.tradeInVehicle?.length > 0 && (vehicle?.appointment?.appointmentType === 'Test Drive' || vehicle?.appointment?.appointmentType === 'Delivery' || vehicle?.appointment?.appointmentType === 'Vehicle Inquiry')"
          class="trade-in-badge"
          [matTooltip]="'testDrive.tradeIn' | translate">{{ 'testDrive.tradeIn' | translate }}</h6>
      </div>
    </div>
    
    
    <!-- <div class="car-image" style="display:flex;">
      <div class="image-div" *ngIf="!isVehicleInquiry">
        <img [src]="carImageAbsoluteURL" (error)="setDefaultImg($event,'images/Sedan_Generic_base_default_34_f_d_490x280.png')" alt="Vehicle Image"/>
      </div>
      <div class="heading-div">
        <h6 *ngIf="isSavedForLater" [ngClass]="'pendingMessage'">{{ 'testDrive.pending' | translate}}</h6>
        <h6 *ngIf="isSavedForLater" [ngClass]="'linkSent'">{{ getLinkSentStatus()}}</h6>
      </div>
      <div>
        <app-card-menu [vehicle]="vehicle" hOffset='-1.4rem' vOffset="0rem" (cancelEvent)="onCancelFlip()"
        (copyEvent)="onCopyDetails()"></app-card-menu>
      </div>
    </div> -->
    <div class="car-name"  [class.empty]="!carNameDisplayText">{{ carNameDisplayText | titlecase}}</div>
   
    <div class="car-info">
      <span class="vin" [class.empty]="!vinDisplayText">{{ vinDisplayText }}</span>
      <span class="vehicleStatus" [class.empty]="!isNVI" *ngIf="isNVI">({{vehicleStatus | translate}})</span>
    </div>
   
    <div class="appointment-details" [class.parts-pickup-spacing]="isPartsPickupAppointment">
      <div class="appointment-row" [class.parts-row-placeholder]="isPartsPickupAppointment">
      <span class="label">{{ 'serviceSchedule.advisor' |  translate}}</span>
      <span class="value">{{ vehicle?.appointment?.advisor?.displayName ? vehicle?.appointment?.advisor?.displayName : '-' }}</span>
      </div>
      <div class="appointment-row">
      <span class="label">{{ 'serviceSchedule.date' |  translate}}</span>
      <span class="value">{{ vehicle?.appointment?.timeSlotId ? vehicle?.appointment?.timeSlotId : '-' }}, {{ vehicle.appointment?.appointmentStartDate ? getDisplayDate(vehicle.appointment?.appointmentStartDate) : '-' }}</span>
      </div>
      <div class="appointment-row" [class.parts-row-placeholder]="isPartsPickupAppointment">
      <span class="label">{{ 'serviceSchedule.transport' |  translate}} </span>
      <span class="value">{{ vehicle?.appointment?.transportation?.category ? vehicle?.appointment?.transportation?.category : '-'}}</span>
      </div>
    </div>
    <!-- <div class="location-info">
      <ng-container *ngIf="appointmentLocationType && appointmentLocationAddress">
        <div class="type"
        title="{{isAtDealership ? ('service.openInMaps' | translate) : ''}}"
        [ngStyle]="{'cursor': isAtDealership ? 'pointer' : 'auto'}"
        (click)="onNavigateToGmap()">
          <asp-icon class='map-icon' name="location_on-24px.svg" color="var(--primary-color)"></asp-icon>
          {{ getTranslation(appointmentLocationType) }}
        </div>
        <div class="address" [title]="appointmentLocationAddress">
          {{ appointmentLocationAddress }}
        </div>
      </ng-container>
    </div> -->

    <mat-form-field appearance="outline" class="actions-select" [ngClass]="isActionDisabled() ? 'disabled' : ''">
      <mat-label class="action-label">Actions</mat-label>
      <mat-select [disabled]="isActionDisabled()">
       <mat-option *ngIf="appointmentExists" [disabled]="isMyKarmaAppointment()" (click)="onCompleteEditAppointment()">{{buttonText}}</mat-option>
       <mat-option *ngIf="appointmentExists" [disabled]="isMyKarmaAppointment()" (click)="onCancelFlip()">{{buttonTextCancel}}</mat-option>
       <mat-option *ngIf="!appointmentExists">Book Appointment</mat-option>
      </mat-select>
   </mat-form-field>

  </div>
  <div class="back cancel-card">
    <div *ngIf="flipTo == 'cancel-appointments'">
    <div class="cancel-loading" *ngIf="isBeingCancelled$ | async; else cancelConfirmation">
      <app-loading loadingSymbol="dots"
                   text="Cancelling"
                   color="var(--dashboard-primary-color)"
                   size="1.6">
      </app-loading>
    </div>
    <ng-template #cancelConfirmation>
      <div class="cancel-desc">{{ 'testDrive.areYouSureYouWantToCancel' | translate}}?</div>
      <asp-info-button name="{{ 'service.yes' | translate }}" type="primary" (click)="onCancel()"></asp-info-button>
      <asp-info-button name="{{ 'service.no' | translate }}" type="secondary" (click)="onCancelFlip()"></asp-info-button>
    </ng-template>
  </div>
    <ng-template  #menuCard>
      <div class="heading-div">
        <h6 *ngIf="isSavedForLater" [ngClass]="'pendingMessage-flip'">{{ 'testDrive.pending' | translate}}</h6>
      </div>
      <app-card-menu
          hOffset="-1.4rem"
          vOffset="0rem"
          [vehicle]="vehicle"
          (copyEvent)="onCopyDetails()"></app-card-menu>
    </ng-template>
    <ng-template #dealerData>
      <div class="call-dealer" (mouseenter)="onHoverDialer()">
        <a [href]="'tel:' + (dealerPhone$ | async)">
          <asp-icon name="phone-dialer-solid.svg" width=".8rem"></asp-icon>
          <span class="dealer-info">{{ (dealerName$ | async) + ' • ' + ((dealerPhone$ | async) | phone) }}</span>
        </a>
      </div>
    </ng-template>
    <ng-container *ngIf="flipTo == 'completeedit-appointments'">
      <div class="all-appointments-card">
        <span class="back-arrow" (click)="cancelAppointmentFlip()"><asp-icon name="arrow_left.svg" height="30px" width="30px"></asp-icon></span>

        <span class="menu-card"> <ng-container [ngTemplateOutlet] = "menuCard"></ng-container> </span>
        <div class="car-name">
          <span *ngIf="vehicle.make && vehicle.model">{{vehicle.make | titlecase}} {{vehicle.model}}</span></div>
        <div class="car-info">
          <span class="vin">{{ vinDisplayText }}</span>
          <span class="vehicleStatus" *ngIf="isNVI">({{vehicleStatus | translate}})</span>
        </div>
        <div class="appointment-location">
          <div title="{{isAtDealership ? ('service.openInMaps' | translate) : ''}}" class="heading"
          [ngStyle]="{'cursor': isAtDealership ? 'pointer' : 'auto'}"
          (click)="onNavigateToGmap()">
          <asp-icon class='map-icon' name="location_on-24px.svg" color="var(--primary-color)" height="1.2rem" width="1.2rem"></asp-icon>
          {{ getTranslation(appointmentLocationType) }}
        </div>
        <div class="address" [title]="appointmentLocationAddress">
          {{ appointmentLocationAddress }}
        </div></div>
        <mat-form-field appearance="outline" class="actions-select">
          <mat-label class="action-label">Actions</mat-label>
          <mat-select>
           <mat-option [disabled]="(isDisabled || isDealerSame)" (click)="onCompleteAppointment()"> {{buttonText}}</mat-option>
           <mat-option (click)="editAppointmentFlip()">{{'testDrive.editDeliveryAppointment' | translate}}</mat-option>
           <mat-option [disabled]="(isDisabled || isDealerSame)" (click)="sendLinkToCustomer()">{{'serviceSchedule.sendLinkToCustomer' | translate}}</mat-option>
          </mat-select>
       </mat-form-field>
        <ng-container [ngTemplateOutlet]="dealerData"></ng-container>
      </div>
    </ng-container>
  
  </div>
</div>
